<div class="component-root">
    <select [(ngModel)]="selectedItem">
        <option *ngFor="let item of _items" [ngValue]="item" >{{displayNameFunction(item)}}</option>
    </select>
    <mat-icon *ngIf="selectedItem != null" (click)="openDialog(selectedItem)">visibility</mat-icon>
</div>
